import clsx from "clsx";

import { DocumentPreview } from "@/components/DocumentPreview";

// TODO: Add support for other file types.

export const FileViewer = ({
  className,
  mimeType,
  url,
}: {
  className?: string;
  mimeType: string;
  url: string;
}) => {
  return (
    <div className={clsx(className)}>
      {mimeType.startsWith("audio/") ? (
        <audio src={url} controls />
      ) : mimeType.startsWith("image/") ? (
        <img src={url} />
      ) : mimeType.startsWith("video/") ? (
        <video src={url} controls />
      ) : (
        <DocumentPreview href={url} />
      )}
    </div>
  );
};
